<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane
        directory-scope="teaching"
        :initial-selection-key="departmentId || null"
        @tree-node-click="treeNodeClick"
      ></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <template slot="buttonSlot">
          <el-form-item>
            <el-button type="warning" icon="el-icon-download" @click="exportDeductions">导出</el-button>
          </el-form-item>
        </template>
      </toolbar>

      <div class="tbl-scroll-host">
        <el-table
          :data="list"
          v-loading="loading"
          row-key="Id"
          class="custom-tbl"
          style="width: 100%"
          height="100%"
        >
          <el-table-column label="日期 / 节次" width="120">
            <template slot-scope="scope">
              <div class="deduction-two-lines">
                <div>{{ formatDateOnly(scope.row.AttendDate) }}</div>
                <div class="deduction-secondary">第{{ scope.row.ClassNo }}节</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="DepartmentName" label="班级" min-width="120"></el-table-column>
          <el-table-column label="课程 / 学生" min-width="140">
            <template slot-scope="scope">
              <div class="deduction-two-lines">
                <div :title="scope.row.SubjectName">{{ scope.row.SubjectName || "-" }}</div>
                <div class="deduction-secondary" :title="scope.row.StudentName">
                  {{ scope.row.StudentName || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型 / 值周项" min-width="160">
            <template slot-scope="scope">
              <div class="deduction-two-lines">
                <div>
                  <el-tag
                    size="mini"
                    :type="scope.row.DeductionKind === 'Late' ? 'warning' : 'danger'"
                    disable-transitions
                  >{{ scope.row.DeductionKindName || kindLabel(scope.row.DeductionKind) }}</el-tag>
                </div>
                <div class="deduction-secondary" :title="scope.row.DutyInspectItemName">
                  {{ scope.row.DutyInspectItemName || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分值 / 操作人" width="120">
            <template slot-scope="scope">
              <div class="deduction-two-lines">
                <div :class="scoreClass(scope.row.Score)">{{ formatScore(scope.row.Score) }}</div>
                <div class="deduction-secondary" :title="scope.row.OperatorName">
                  {{ scope.row.OperatorName || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="角色 / 备注" min-width="170">
            <template slot-scope="scope">
              <div class="deduction-two-lines">
                <div>{{ roleLabel(scope.row.OperatorRole) || "-" }}</div>
                <div class="deduction-secondary" :title="scope.row.Remark">
                  {{ scope.row.Remark || "-" }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="写入时间" width="160">
            <template slot-scope="scope">{{ formatDateTime(scope.row.CreateTime) }}</template>
          </el-table-column>
        </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          style="float: right"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-col>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "@/components/DepartmentPane";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import { resolveActiveSchoolId } from "../../utils/deptCascaderProps";
import {
  getCourseAttendanceDutyDeductions,
  getCourseAttendanceDutyDeductionsExport,
} from "../../api/modules/schedule-course";

/**
 * 课堂考勤迟到/早退值周扣分明细。创建于 2026-10-20
 */
export default {
  name: "CourseAttendanceDutyDeduction",
  components: { DepartmentPane, Toolbar },
  data() {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 30);
    const fmt = (d) => {
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${y}-${m}-${day}`;
    };
    let context = {};
    try {
      context = JSON.parse(sessionStorage.getItem("courseAttendanceDutyDeductionContext") || "{}");
      sessionStorage.removeItem("courseAttendanceDutyDeductionContext");
    } catch (e) {
      context = {};
    }
    const q = {
      ...context,
      ...((this.$route && this.$route.query) || {}),
    };
    const qStart = q.startDate || q.date || "";
    const qEnd = q.endDate || q.date || "";
    return {
      buttonList: [],
      searchList: [
        { label: "开始日期", key: "startDate", type: "date", initValue: qStart || fmt(start) },
        { label: "结束日期", key: "endDate", type: "date", initValue: qEnd || fmt(end) },
        {
          label: "类型",
          key: "deductionKind",
          type: "select",
          clearable: true,
          initValue: q.deductionKind || "",
          options: [
            { label: "全部", value: "" },
            { label: "迟到", value: "Late" },
            { label: "早退", value: "EarlyLeave" },
          ],
        },
        { label: "学生姓名", key: "keyword", type: "input", initValue: q.keyword || "" },
      ],
      filters: {
        startDate: qStart || fmt(start),
        endDate: qEnd || fmt(end),
        deductionKind: q.deductionKind || "",
        keyword: q.keyword || "",
      },
      schoolId: q.schoolId ? Number(q.schoolId) : 0,
      departmentId: q.departmentId ? Number(q.departmentId) : 0,
      // 从课程考勤统计页带入的班级，优先于组织树初始化时的默认节点。
      routeDepartmentId: q.departmentId ? Number(q.departmentId) : 0,
      list: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      listRequestId: 0,
    };
  },
  methods: {
    /**
     * 向上查找指定组织类型的部门 Id
     */
    findAncestorDeptId(node, target) {
      let cur = node;
      while (cur) {
        const row = cur.data || cur;
        const type = String((row.DeptOrgType || row.deptOrgType) || "").toLowerCase();
        if (type === target) {
          const id = row.value != null ? row.value : row.Id;
          return id && String(id) !== "0" ? id : 0;
        }
        cur = cur.parent;
      }
      return 0;
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = { ...this.filters, ...item.search };
      }
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    treeNodeClick(data, node) {
      if (!data) return;
      const orgType = String(data.DeptOrgType || data.deptOrgType || "").toLowerCase();
      const deptId = data.value != null ? data.value : data.Id;
      if (!deptId || String(deptId) === "0") {
        this.$message({ message: "请选择具体的学校或班级", type: "error" });
        this.list = [];
        this.total = 0;
        return;
      }

      // DepartmentPane 初始化时可能自动触发学校/默认班级节点事件，
      // 不能覆盖从课程考勤统计页带入的当前班级。
      if (this.routeDepartmentId > 0 && Number(deptId) !== this.routeDepartmentId) {
        const routeDepartmentId = this.routeDepartmentId;
        this.routeDepartmentId = 0;
        this.schoolId = Number(resolveActiveSchoolId(this) || this.schoolId) || 0;
        this.departmentId = routeDepartmentId;
        if (this.departmentId > 0) {
          this.page = 1;
          this.loadList();
        }
        return;
      }
      if (this.routeDepartmentId > 0 && Number(deptId) === this.routeDepartmentId) {
        this.routeDepartmentId = 0;
      }

      const schoolId =
        orgType === "school" || orgType === "affiliateschool"
          ? deptId
          : this.findAncestorDeptId(node, "school") ||
            this.findAncestorDeptId(node, "affiliateschool") ||
            resolveActiveSchoolId(this) ||
            this.schoolId;

      if (!schoolId) {
        this.$message({ message: "无法识别所属学校，请先选择学校节点", type: "warning" });
        return;
      }

      this.schoolId = Number(schoolId) || 0;
      // 选学校时查全校；选下级（班级等）时按部门过滤
      this.departmentId =
        orgType === "school" || orgType === "affiliateschool" ? 0 : Number(deptId) || 0;
      this.page = 1;
      this.loadList();
    },
    handleQuery() {
      this.page = 1;
      this.loadList();
    },

    /**
     * 导出当前筛选结果中的课堂考勤扣分明细。创建于 2026-10-20
     */
    async exportDeductions() {
      if (!this.schoolId) {
        this.$message({ message: "请先选择学校或班级", type: "warning" });
        return;
      }
      try {
        const response = await getCourseAttendanceDutyDeductionsExport({
          schoolId: this.schoolId,
          departmentId: this.departmentId > 0 ? this.departmentId : undefined,
          startDate: this.filters.startDate || "",
          endDate: this.filters.endDate || "",
          deductionKind: this.filters.deductionKind || "",
          keyword: this.filters.keyword || "",
        });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `课堂考勤扣分明细_${this.filters.startDate || ""}_${this.filters.endDate || ""}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("课堂考勤扣分明细导出失败:", error);
        this.$message({ message: "导出失败", type: "error" });
      }
    },

    loadList() {
      const schoolId = this.schoolId || resolveActiveSchoolId(this) || 0;
      if (!schoolId) {
        this.$message({ message: "请先选择学校或班级", type: "warning" });
        return;
      }
      this.schoolId = Number(schoolId) || 0;
      const requestId = ++this.listRequestId;
      this.loading = true;
      const params = {
        schoolId: this.schoolId,
        page: this.page,
        pageSize: this.pageSize,
        startDate: this.filters.startDate || "",
        endDate: this.filters.endDate || "",
        deductionKind: this.filters.deductionKind || "",
        keyword: this.filters.keyword || "",
      };
      if (this.departmentId > 0) {
        params.departmentId = this.departmentId;
      }
      getCourseAttendanceDutyDeductions(params)
        .then((res) => {
          if (requestId !== this.listRequestId) return;
          const body = res && res.data;
          const r = body && body.response;
          if (body && body.success === false) {
            this.$message({ message: (body && body.msg) || "查询失败", type: "error" });
            this.list = [];
            this.total = 0;
            return;
          }
          this.list = r && Array.isArray(r.data) ? r.data : [];
          this.total = r && r.dataCount != null ? r.dataCount : 0;
        })
        .catch(() => {
          if (requestId !== this.listRequestId) return;
          this.list = [];
          this.total = 0;
        })
        .finally(() => {
          if (requestId === this.listRequestId) this.loading = false;
        });
    },
    handlePageChange(p) {
      if (p === this.page) return;
      this.page = p;
      this.loadList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.loadList();
    },
    kindLabel(kind) {
      if (kind === "Late") return "迟到";
      if (kind === "EarlyLeave") return "早退";
      return kind || "-";
    },
    /** 操作角色中文；接口存 Teacher / HeadTeacher。最后更新：2026-10-31 */
    roleLabel(role) {
      const map = {
        Teacher: "任课教师",
        HeadTeacher: "班主任",
        HomeroomTeacher: "班主任",
        Student: "学生",
      };
      return map[role] || role || "-";
    },
    formatScore(val) {
      if (val === null || val === undefined || val === "") return "-";
      const n = Number(val);
      if (isNaN(n)) return val;
      return Number.isInteger(n) ? String(n) : n.toFixed(2);
    },
    scoreClass(val) {
      const n = Number(val);
      if (!isNaN(n) && n === 0) return "score-zero";
      return "score-negative";
    },
    formatDateOnly(v) {
      if (!v) return "";
      if (typeof v === "string") return v.split(" ")[0].split("T")[0];
      try {
        const d = new Date(v);
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d
          .getDate()
          .toString()
          .padStart(2, "0")}`;
      } catch (e) {
        return v;
      }
    },
    formatDateTime(v) {
      if (!v) return "";
      if (typeof v === "string") {
        const normalized = v.replace("T", " ");
        if (normalized.length >= 19) return normalized.substring(0, 19);
      }
      try {
        const d = new Date(v);
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
          `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      } catch (e) {
        return v;
      }
    },
    /**
     * 路由带入班级时，用当前顶部学校尝试直接拉数
     */
    tryLoadFromRouteQuery() {
      const fromRoute = this.$route && this.$route.query && this.$route.query.schoolId;
      const fromStore = fromRoute || resolveActiveSchoolId(this);
      if (fromStore) {
        this.schoolId = Number(fromStore) || 0;
      }
      if (this.schoolId > 0 && this.departmentId > 0) {
        this.loadList();
      }
    },
  },
  mounted() {
    const routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.tryLoadFromRouteQuery();
  },
};
</script>

<style scoped>
.deduction-two-lines {
  line-height: 1.35;
  overflow: hidden;
}

.deduction-two-lines > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deduction-secondary {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.score-negative,
.score-zero {
  font-weight: 700;
  letter-spacing: 0.2px;
}

.score-negative {
  color: #f04438;
}

.score-zero {
  color: #909399;
}
</style>
